import React from 'react';
// ---------------  For Ui ----------------------------------
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import withStyles from '@material-ui/core/styles/withStyles';
import InputLabel from '@material-ui/core/InputLabel';
import { Redirect } from 'react-router-dom'
// ---------------  For Redux ----------------------------------
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';



class RenderInput extends React.PureComponent {

  state = {}

  componentDidMount() {
    const { id, defaultValue, } = this.props;
    this.setState({ [id]: defaultValue });
  }

  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value
    })
  }

  render() {
    const { id, title, defaultValue, isRequired, type } = this.props;

    // if(!this.state[id]) return null;

    switch (type) {
      case 'text':
        return <FormControl margin="normal" required={isRequired} fullWidth>
          <InputLabel htmlFor={id}>{title}</InputLabel>
          <Input
            onChange={this.handleChange}
            value={this.state[id] || null}
            id={id} name={id} autoComplete="text" />
        </FormControl>
        default:
          return <FormControl margin="normal" required={isRequired} fullWidth>
            <InputLabel htmlFor={id}>{title}</InputLabel>
            <Input
              onChange={this.handleChange}
              value={this.state[id] || null}
              id={id} name={id} autoComplete="text" />
          </FormControl>
    }
  }


}

export default RenderInput